<template>
  <div class="add-contact-button">
    <div class="label" v-if="showLabel">
      <template v-if="!isLoading">
        <div class="welcome-message large">
          Assist your customers wherever they are with live augmented reality based video sharing.
        </div>
        <div class="welcome-message">
          The customer will receive a link via SMS to download RemotePC Vision on their mobile device.
        </div>
        <div class="icon">
          <fa-icon icon="chevron-down"></fa-icon>
        </div>
      </template>
    </div>
    <transition name="contact-form">
      <div class="add-button" @click="openForm" v-if="isButtonVisible && (!isLoading || showLabel)">
        <img src="../../assets/icon_add.svg" />
      </div>
    </transition>
  </div>
</template>

<script>
  import LoadingLogo from "../LoadingLogo";
  export default {
    name: "AddContactButton",
    components: {LoadingLogo},
    props: {
      isButtonVisible: {
        type: Boolean,
        default: true
      },
      showLabel: {
        type: Boolean,
        default: true
      },
      isLoading: {
        type: Boolean
      }
    },

    methods: {
      openForm() {
        this.$emit('openForm')
      }
    },

    mounted() {
      this.$nextTick()
        .then(() =>  {
          this.$refs.loading && this.$refs.loading.setLoading(this.isLoading)
        })
    },

    watch: {
      isLoading() {
        this.$refs.loading && this.$refs.loading.setLoading(this.isLoading)
      }
    }
  }
</script>

<style lang="scss">
@import "AddContactButton";
</style>
